import React from 'react';

export const sizes = ['small', 'medium', 'large', 'header'] as const;
export type SizeProp = (typeof sizes)[number];

export interface LogoProps {
  invert?: boolean;
  size?: SizeProp;
  [key: string]: unknown; // other props
}

/* eslint-disable @typescript-eslint/ban-types */
export type LogoComponent<T = {}> = React.FunctionComponent<LogoProps & React.ComponentProps<'svg'> & T>;

export interface LogoSize {
  width: string;
  height: string;
}

export type SizeMap = Record<SizeProp, LogoSize>;
